export default __webpack_public_path__ + "static/media/image1.c92bf560.png";